export const TRANSLATION_GROUP_PLAYER_MAIN_DATA = Symbol('admin-players.player-data');
export const PLAYER_MAIN_DATA_ROUTE = Symbol('main_data');
